import React, { createContext, useState, useEffect } from "react";
import WarningLoginModal from "../buildingPages/modals/WarningLoginModal";
import { configConsumerProps } from "antd/es/config-provider";

export const BuildingContext = createContext();

export const BuildingProvider = ({ children }) => {
  const [buildings, setBuildings] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const BACK_API_BASE_URL = process.env.REACT_APP_BACK_API_BASE_URL;

  // 등록된 건물 목록을 가져오는 함수
  const fetchBuildings = async () => {
    try {
      // console.log("token",sessionStorage.getItem("token"))
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/building/load/all`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "GET",
        }
      );

      if (response.ok) {
        const data = await response.json();
        const safeData = data && Object.keys(data).length > 0 ? data : [];
        sessionStorage.setItem("building", JSON.stringify(safeData));
        setBuildings(data);
        // console.log(data)
      } else {
        console.error("Failed to fetch buildings:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching buildings:", error);
    } finally {
      return false;
    }
  };

  // 특정 건물의 상세 정보를 가져오는 함수
  const fetchBuildingDetails = async (buildingId) => {
    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/buildings/${buildingId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "GET",
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching building details:", error);
      return null;
    }
  };

  // 건물 삭제 함수
  const deleteBuilding = async (buildingId) => {
    // console.log("건물아이디",buildingId)
    // console.log("토큰",sessionStorage.getItem("token"))
    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/building/delete/${buildingId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "GET",
        }
      );
      // console.log("건물삭제:",response)

      if (response.ok) {
        const updatedBuildings = buildings.filter(
          (building) => building.id !== buildingId
        );
        setBuildings(updatedBuildings);
        await fetchBuildings();
      } else {
        console.error("Failed to delete building:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting building:", error);
    }
  };

  // 건물 정보 업데이트 함수
  const updateBuilding = async (updatedBuilding) => {
    try {
      const buildingId = updatedBuilding.id;

      const response = await fetch(
        `${BACK_API_BASE_URL}/api/building/modify/${buildingId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "POST",
          // body: JSON.stringify(updatedBuilding),
          body: JSON.stringify({
            buildingName: updatedBuilding.buildingName,
            buildingTotalArea: updatedBuilding.buildingTotalArea,
            buildingGroundFloor: updatedBuilding.buildingGroundFloor,
            buildingBasementFloor: updatedBuilding.buildingBasementFloor,
            buildingWaterMeter: updatedBuilding.buildingWaterMeter,
          }),
        }
      );
      // console.log("건물정보",buildingId)
      const data = await response.json();
      // console.log(data);

      if (response.ok) {
        const updatedBuildings = buildings.map((b) =>
          b.id === updatedBuilding.id ? { ...b, ...updatedBuilding } : b
        );
        setBuildings(updatedBuildings);
        window.location.reload();
      } else {
        console.error("Failed to update building:", response.statusText);
      }
    } catch (error) {
      console.error("Error updating building:", error);
    }
    window.location.reload();
  };

  return (
    <BuildingContext.Provider
      value={{
        buildings,
        deleteBuilding,
        updateBuilding,
        fetchBuildings,
        fetchBuildingDetails,
        userRole,
      }}
    >
      {children}
    </BuildingContext.Provider>
  );
};
